export const GRAPHQL_ERROR_CODE = {
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_SERVER_ERROR: 'INTERNAL SERVER ERROR',
  INVALID_TOKEN: 'INVALID TOKEN',
  NOT_FOUND: 'NOT FOUND',
  UNAUTHORIZED: 'UNAUTHORIZED',
}
